// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2957":"css/app.6815","9894":"css/admin-app.6815"}[chunkId] + ".css";
};